<template>
    <DayTemplateCreationButton :empty="false"></DayTemplateCreationButton>
</template>

<script>
    import store from '@/store/index.js'
    import Translations from '@/store/translations';
    import DayTemplateCreationButton from './DayTemplateCreationButton.vue';

    export default {
        name: "PlanningSectionActions",
        store,
        components: {
            DayTemplateCreationButton,
        },
        computed: {
            Translations: () => Translations,
        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>